import React, { useState, useEffect } from 'react';
import devuelveReglamentoSanciones from './devuelveReglamentoSanciones';
import './piton.css';
import axios from 'axios';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import Swal from "sweetalert2";
import socket from '../tools/socke';

const SelectorCantidadSancionRecursa = ({ sancion, valores }) => {
  const Usuario = ObtieneDatosCookies();
  const sanciones = devuelveReglamentoSanciones();

  const [selectedSancion, setSelectedSancion] = useState(sancion.articulo);
  const [selectedInciso, setSelectedInciso] = useState(sancion.inciso.toString());
  const [opcionSeleccionada, setOpcionSeleccionada] = useState(parseInt(sancion.cantidadConfirma, 10) || 0);
  const valorOriginal = parseInt(sancion.cantidadConfirma, 10) || 0;
  const [elMinimo, setElMinimo] = useState(0);
  const [elMaximo, setElMaximo] = useState(0);
  const [resuelveRecursoArea, setResuelveRecurso] = useState("");
  const [modo, setModo] = useState(null); // "disminuir", "confirmar", "anular"

  const creaSancionForm = async (e) => {
    e.preventDefault();
  
    if (!selectedSancion || !selectedInciso || (!opcionSeleccionada && modo === "disminuir") || !resuelveRecursoArea) {
      Swal.fire({
        title: "Error",
        text: "Todos los campos deben estar completos.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
  
    const confirmacion = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Vas a ${modo === "disminuir" ? "disminuir" : modo === "confirmar" ? "confirmar" : modo === "anular" ? "anular" : "resolver"} la sanción.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    });
  
    if (!confirmacion.isConfirmed) return;
  
    let cantidadFinal = opcionSeleccionada;
    if (modo == "confirmar") cantidadFinal = valorOriginal;
    if (modo == "anular") cantidadFinal = 0;
  
    const datos = {
      cantidadResuelveRecurso: cantidadFinal,
      resuelveRecurso:
        resuelveRecursoArea +
        (cantidadFinal === valorOriginal ? " (Confirmar)" : cantidadFinal === 0 ? " (Anulada)" : " (Disminuir)"),
      usuarioResuelveRecurso: `${Usuario.nombre} ${Usuario.apellido}`,
      fechaResuelveRecurso: new Date(),
      estado: "Resuelto Reclamada"
    };
  
    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;
    const token = btoa(`${username}:${password}`);
  
    try {
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        datos,
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );
  
      if (response.data.success) {
        Swal.fire({
          title: "Sanción Reclamada Resuelta con éxito",
          text: `Se resolvió una sanción para el cadete con DNI ${sancion.cadeteDni}`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          socket.emit("sancionEvent", "");
          valores(datos);
        });
      } else {
        Swal.fire({
          title: response.data.message,
          text: "Compruebe los datos, algo pudo salir mal.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
  
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Fallo la generación, algo no resultó correctamente.",
        icon: "error",
        confirmButtonText: "OK",
      });
//       console.log('Error al enviar los datos:', error);
    }
  };
  

  const handleSancionChange = (e) => {
    setSelectedSancion(e.target.value);
    setSelectedInciso('');
  };

  const selectedSancionData = sanciones.find((s) => s.id === selectedSancion) || {};
  const incisos = selectedSancionData.Incisos || [];
  const selectedIncisoData = incisos.find((inciso) => Object.values(inciso)[0] === selectedInciso.split(' - ')[1]?.trim()) || null;

  useEffect(() => {
    if (selectedIncisoData) {
      setElMinimo(Number(selectedIncisoData.minimo) || 0);
      setElMaximo(Number(valorOriginal) || 0);
    } else {
      setElMinimo(0);
      setElMaximo(0);
    }
  }, [selectedIncisoData]);

  const rango = (min, max) => Array.from({ length: max - min + 1 }, (_, i) => min + i);
  const resultadoRango = rango(elMinimo, elMaximo)
    .filter((v) => v <= valorOriginal)
    .sort((a, b) => b - a); // orden descendente

  return (
    <form className='formLuis' onSubmit={creaSancionForm}>
      <label>Sanción:</label>
      <select disabled className={`form-control ${selectedSancion ? "is-valid" : "is-invalid"}`} onChange={handleSancionChange} value={selectedSancion}>
        <option value="">-- Selecciona --</option>
        {sanciones.map((sancion) => (
          <option key={sancion.id} value={sancion.id}>{sancion.id} - {sancion.descripcion}</option>
        ))}
      </select>

      <label>Inciso:</label>
      <select disabled className={`form-control ${selectedInciso ? "is-valid" : "is-invalid"}`} value={selectedInciso} onChange={(e) => setSelectedInciso(e.target.value)}>
        <option value="">Selecciona...</option>
        {incisos.map((inciso, index) => {
          const clave = Object.keys(inciso)[0];
          const valor = Object.values(inciso)[0];
          return (
            <option key={index} value={`${clave} - ${valor}`}>{clave} - {valor.length > 100 ? valor.substring(0, 100) + "..." : valor}</option>
          );
        })}
      </select>

      <textarea className="textArea" value={selectedInciso ? selectedInciso.split(' - ')[1] : ''} disabled rows="3" />

      {modo === "disminuir" && (
        <>
          <label>Cantidad:</label>
          <select className={`form-control ${opcionSeleccionada ? "is-valid" : "is-invalid"}`} value={opcionSeleccionada} onChange={(e) => setOpcionSeleccionada(parseInt(e.target.value, 10))}>
            <option value="">Selecciona...</option>
            {resultadoRango.map((valor, index) => (
              <option key={index} value={valor}>
                {valor === 0.33 ? 'Apercibimiento' : valor === 16 ? 'Baja' : valor}
              </option>
            ))}
          </select>
        </>
      )}

<label>
  {modo === "disminuir" && "Resuelve Disminuir:"}
  {modo === "confirmar" && "Resuelve Confirmar:"}
  {modo === "anular" && "Resuelve Anular:"}
  {!modo && "Resuelve:"}
</label>

      <textarea className={`form-control ${resuelveRecursoArea ? "is-valid" : "is-invalid"}`} onChange={(e) => setResuelveRecurso(e.target.value)} value={resuelveRecursoArea} rows="3" />

      <div className="btn-group mt-2" role="group">
        <button type="submit" className='btn btn-success'>
          Resolver sobre Reclamo
        </button>

        <button
          type="button"
          className={`btn btn-outline-primary btn-mode ${modo === "disminuir" ? "active-mode" : ""}`}
          onClick={() => setModo("disminuir")}
        >
          Disminuir
        </button>

        <button
          type="button"
          className={`btn btn-outline-info btn-mode ${modo === "confirmar" ? "active-mode" : ""}`}
          onClick={() => setModo("confirmar")}
        >
          Confirmar
        </button>

        <button
          type="button"
          className={`btn btn-outline-danger btn-mode ${modo === "anular" ? "active-mode" : ""}`}
          onClick={() => setModo("anular")}
        >
          Anular
        </button>
      </div>
    </form>
  );
};

export default SelectorCantidadSancionRecursa;
